var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import useEmotionStyles from '../../hooks/useEmotionStyles';
import List from '../List';
import Button from '@mui/material/Button';
var styles = function (theme, _a) {
    var _b, _c, _d, _e, _f;
    var isSelected = _a.isSelected;
    return ({
        root: __assign(__assign({ height: '100%', display: 'flex', flexDirection: 'column', padding: "".concat(theme.spacing(2), " ").concat(theme.spacing(2)), transition: '.5s' }, (isSelected && {
            borderColor: theme.palette.primary.main,
        })), (_b = {}, _b[theme.breakpoints.down('md')] = {
            flexDirection: 'row',
        }, _b[theme.breakpoints.between('md', 'xl')] = {
            padding: "".concat(theme.spacing(2), " ").concat(theme.spacing(1)),
            border: 'none',
        }, _b)),
        headIconWrapper: (_c = {
                marginBottom: theme.spacing(2)
            },
            _c[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _c[theme.breakpoints.down('lg')] = {
                marginRight: theme.spacing(4),
            },
            _c['& svg'] = (_d = {
                    width: '40px',
                    height: '40px',
                    fill: isSelected ? theme.palette.primary.main : theme.palette.grey[500],
                    transition: '.5s'
                },
                _d[theme.breakpoints.down('lg')] = {
                    width: '65px',
                    height: '65px',
                },
                _d),
            _c),
        content: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            maxWidth: '500px',
        },
        list: (_e = {
                flex: 1,
                marginBottom: theme.spacing(2)
            },
            _e['& p'] = {},
            _e),
        btnWrapper: (_f = {
                display: 'flex',
                justifyContent: 'center'
            },
            _f[theme.breakpoints.down('md')] = {
                justifyContent: 'start',
            },
            _f[theme.breakpoints.down('sm')] = {
                justifyContent: 'center',
            },
            _f),
        btn: {
            minWidth: '80%',
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
    });
};
var ExplainedChoiceBlock = function (_a) {
    var value = _a.value, label = _a.label, list = _a.list, btnTitle = _a.btnTitle, _b = _a.activeBtnTitle, activeBtnTitle = _b === void 0 ? '' : _b, Icon = _a.Icon, onSelect = _a.onSelect, isSelected = _a.isSelected;
    var cs = useEmotionStyles(styles, {
        isSelected: isSelected,
    });
    var handleBtnClick = useCallback(function () {
        onSelect(value);
    }, [value, onSelect]);
    var btnText = isSelected ? activeBtnTitle || btnTitle : btnTitle;
    var btnVariant = isSelected ? 'contained' : 'outlined';
    return (React.createElement(Paper, { variant: 'outlined', className: cs.root },
        React.createElement("div", { className: cs.headIconWrapper },
            React.createElement(Icon, null)),
        React.createElement("div", { className: cs.content },
            React.createElement(Box, { mb: 2 },
                React.createElement(Typography, { variant: 'h4' }, label)),
            React.createElement(List, { items: list, className: cs.list, isCheckIconVisible: function (theme) {
                    return theme.breakpoints.not('md');
                } }),
            React.createElement("div", { className: cs.btnWrapper },
                React.createElement(Button, { onClick: handleBtnClick, variant: btnVariant, color: "primary", size: "large", className: cs.btn }, btnText)))));
};
export default ExplainedChoiceBlock;
